<script >
import { ref } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  entryType: {
    type: String,
    default: 'finder'
  },
  entryValue: {
    type: String,
    default: ''
  },
  canUseSavedSearches: {
    type: Boolean,
    default: false
  },
  canManageSavedSearches: {
    type: Boolean,
    default: false
  },
  savedSearches: {
    type: Array,
    default: () => []
  },
  canSaveCurrentSearch: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const savedSearchDraft = ref('');
  const editingSavedSearchName = ref('');
  const editingSavedSearchDraft = ref('');
  const startSavedSearchEdition = search => {
    editingSavedSearchName.value = search.name;
    editingSavedSearchDraft.value = search.label;
  };
  const resetSavedSearchEdition = () => {
    editingSavedSearchName.value = '';
    editingSavedSearchDraft.value = '';
  };
  const submitSavedSearchEdition = () => {
    if (!editingSavedSearchName.value || !editingSavedSearchDraft.value.trim()) {
      return;
    }
    emit('rename-saved-search', {
      name: editingSavedSearchName.value,
      newName: editingSavedSearchDraft.value.trim()
    });
    resetSavedSearchEdition();
  };
  const submitSavedSearchCreate = () => {
    if (!savedSearchDraft.value.trim()) {
      return;
    }
    emit('create-saved-search', {
      name: savedSearchDraft.value.trim()
    });
    savedSearchDraft.value = '';
  };
  return {
    emit,
    savedSearchDraft,
    editingSavedSearchName,
    editingSavedSearchDraft,
    startSavedSearchEdition,
    resetSavedSearchEdition,
    submitSavedSearchEdition,
    submitSavedSearchCreate
  };
};
export default __sfc_main;
</script>

<template>
  <div class="charting-workspace-fragment">
    <section class="charting-workspace-drawer-section">
        <div class="flex items-center justify-between gap-3">
            <div class="text-xs font-semibold uppercase tracking-wide text-muted-color">Mis busquedas</div>
            <Tag v-if="!canUseSavedSearches" value="Restringido" severity="warn" />
            <Tag v-else :value="String(savedSearches.length)" severity="secondary" />
        </div>

        <div v-if="canUseSavedSearches && savedSearches.length" class="mt-3 flex flex-col gap-3">
            <div v-for="search in savedSearches" :key="search.id" class="charting-workspace-management-row">
                <template v-if="editingSavedSearchName === search.name">
                    <InputText v-model="editingSavedSearchDraft" class="w-full" />
                    <div class="mt-3 flex gap-2">
                        <Button label="Guardar" size="small" @click="submitSavedSearchEdition" />
                        <Button label="Cancelar" size="small" severity="secondary" outlined @click="resetSavedSearchEdition" />
                    </div>
                </template>
                <template v-else>
                    <button type="button" class="charting-workspace-drawer-row" :class="{ 'is-active': entryType === 'saved-search' && entryValue === search.name }" @click="emit('open-source', { type: 'saved-search', value: search.name })">
                        <span class="font-medium">{{ search.label }}</span>
                        <i class="pi pi-folder-open text-xs text-muted-color"></i>
                    </button>
                    <div v-if="canManageSavedSearches" class="mt-2 flex gap-2">
                        <Button label="Editar" size="small" severity="secondary" outlined @click="startSavedSearchEdition(search)" />
                        <Button label="Eliminar" size="small" severity="danger" text @click="emit('remove-saved-search', search.name)" />
                    </div>
                </template>
            </div>
        </div>
        <div v-else-if="canUseSavedSearches" class="brand-empty-state mt-3 rounded-xl border border-dashed p-4 text-sm">No hay busquedas guardadas visibles.</div>
        <div v-else class="brand-empty-state mt-3 rounded-xl border border-dashed p-4 text-sm">Tu plan actual no permite reutilizar búsquedas guardadas.</div>

        <div v-if="canManageSavedSearches" class="mt-4 border-t border-surface-200 pt-4 dark:border-surface-800">
            <div class="text-xs font-semibold uppercase tracking-wide text-muted-color">Guardar búsqueda actual</div>
            <InputText v-model="savedSearchDraft" class="mt-3 w-full" placeholder="Nombre de la búsqueda" />
            <Button class="mt-3" label="Guardar búsqueda" icon="pi pi-save" :disabled="!savedSearchDraft.trim() || !canSaveCurrentSearch" @click="submitSavedSearchCreate" />
            <div v-if="!canSaveCurrentSearch" class="mt-2 text-xs text-muted-color">Necesitas tener el finder cargado para guardar la búsqueda actual.</div>
        </div>
    </section>
  </div>
</template>
